import {createDialogActions} from '../CommonDialog/commonDialogActions';
import * as assetService from '../../../services/Assets/assetService.js';
import Network from 'infrastructure/js/modules/network';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: () => null
  },

  jsxOverrides: {
    fetchAsset(assetId, callbacks = {}) {
      return function (dispatch) {
        return assetService.getAssetByBusinessId(assetId).then((response) => {
          if (!Network.isResponseValid(response)) {
            const error = createLabelHelper('mat.locationPage.view.assignRemoveAssetsTags.dialog.').get('result.assetNotFound');
            callbacks.onError?.(error);
            return;
          }
          callbacks.onSuccess?.(response.data);
        }).catch(() => {
          callbacks.onError?.('Error fetching asset');
        });
      };
    },

    assignTag(assetId, tag, callbacks = {}) {
      return function (dispatch) {
        return assetService.assignTagToAsset({ assetBusinessId: assetId, tagKey: tag }).then((response) => {
          if (!Network.isResponseValid(response)) {
            const errorCode = response?.applicationResponseStatus?.errorCode;
            const errorParams = response?.applicationResponseStatus?.errors?.mainError?.params || [];
            const error = createLabelHelper('').get(errorCode, '', errorParams) || 'Failed to assign tag';

            callbacks.onError?.(error);
            return;
          }
          callbacks.onSuccess?.();
        }).catch(() => {
          callbacks.onError?.('Error assigning tag');
        });
      };
    },

    removeTag( tag, callbacks = {}) {
      return function (dispatch) {
        return assetService.removeTagFromAsset({ tagKey: tag }).then((response) => {
          if (!Network.isResponseValid(response)) {
            const errorCode = response?.applicationResponseStatus?.errorCode;
            const errorParams = response?.applicationResponseStatus?.errors?.mainError?.params || [];
            const error = createLabelHelper('').get(errorCode, '', errorParams) || 'Failed to remove tag';

            callbacks.onError?.(error);
            // callbacks.onError?.('Failed to remove tag');
            return;
          }
          callbacks.onSuccess?.(response?.data);
        }).catch(() => {
          callbacks.onError?.('Error removing tag');
        });
      };
    },
  }
});
